import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { get_address } from '../../api/Product';

const Address = () => {
    const [get_address_list, set_Address_list] = useState([]);
    const get_user_data = localStorage.getItem("user");
    const parsedUserData = JSON.parse(get_user_data); 

    // Filter only "shipping" addresses
    const lastShippingAddress = get_address_list?.filter((item) => item?.type == "shipping")?.at(-1);

    // Filter only "shipping" addresses
    const lastBillingAddress = get_address_list?.filter((item) => item?.type == "billing")?.at(-1);

    const token = localStorage.getItem("token");
    const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
    };

    useEffect(() => {
        const handle_address_list = async () => {
            try {
                const response = await get_address(headers);
                set_Address_list(response?.data)
                console.log("response", response?.data)
            }
            catch (error) {
                console.log("error", error)
            }
        }
        handle_address_list();
    }, [])

    return (
        <div className="p-6 max-w-2xl mx-auto">
            <p className="text-gray-600 text-sm mb-4">
                The following addresses will be used on the checkout page by default.
            </p>

            {/* Billing Address */}
            {/* <div className="mb-6">
                <div className="flex justify-between items-center">
                    <h2 className="text-xl font-bold text-gray-800">Billing address</h2>
                    {
                        lastBillingAddress ? (
                            <Link to="/edit_billing_address" className="text-red-600 font-medium hover:underline">
                                Edit Billing address
                            </Link>
                        ) : (
                            <Link to="/billing_address" className="text-red-600 font-medium hover:underline">
                                Add Billing address
                            </Link>
                        )
                    }

                </div>

                {lastBillingAddress ? (
                    <div key={lastBillingAddress?.id || Math.random()} className="text-sm text-gray-700">
                        <p className="font-semibold">{parsedUserData?.name}</p>
                        <p>{lastBillingAddress?.address}</p>
                        <p>{lastBillingAddress?.city}, {" "}{lastBillingAddress?.state}, {" "}{lastBillingAddress?.country}</p>
                        {
                            lastBillingAddress?.phone && (
                                <p><strong>Phone : </strong>{lastBillingAddress?.phone}</p>
                            )
                        }
                    </div>
                ) : (
                    <p className="text-gray-500 text-sm mt-2">
                        You have not set up this type of address yet.
                    </p>
                )}

            </div> */}

            {/* Shipping Address */}
            <div>
                <div className="flex justify-between items-center">
                    <h2 className="text-xl font-bold text-gray-800">Billing address</h2>
                    {
                        lastShippingAddress ? (
                            <Link to="/edit_shipping_address" className="text-red-600 font-medium hover:underline">
                                Edit Billing address
                            </Link>
                        ) : (
                            <Link to="/shipping_address" className="text-red-600 font-medium hover:underline">
                                Add Billing address
                            </Link>
                        )
                    }

                </div>
                <div className="bg-gray-50">
                    {lastShippingAddress ? (
                        <div key={lastShippingAddress?.id || Math.random()} className="text-sm text-gray-700">
                            <p className="font-semibold">{parsedUserData?.name}</p>
                            <p>{lastShippingAddress?.address}</p>
                            <p>{lastShippingAddress?.city} , {" "} {lastShippingAddress?.state}, {" "} {lastShippingAddress?.country}</p>

                            {
                                lastShippingAddress?.phone && (
                                    <p><strong>Phone : </strong>{lastShippingAddress?.phone}</p>
                                )
                            }
                        </div>
                    ) : (
                        <p className="text-gray-500 text-sm mt-2">
                            You have not set up this type of address yet.
                        </p>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Address
